import Vue from 'vue';
import Component from 'vue-class-component';
import * as api from 'core/api';
import * as auth from 'core/auth';
import router from 'src/router';
import * as i18next from 'i18next';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AuthBySMSComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init
    
    view: string = 'loading';

    mounted(){
        if (this.$auth.authenticated) {
            let redirect = '/account';
                
            if (this.$route.query.redirect) {
                redirect = this.$route.query.redirect as string;
            }

            location.href = redirect;
        } else {
            this.$nextTick(function() {
                if (this.$route.query.token) {
                    // If token in url the try to confirm user
                    this.$auth.confirm(this.$route.query.token as string).then(
                        (result: api.User) => {
                            if (result.hasPassword) {
                                window.location.href = '/account';
                            }
                            else {
                                router.push('/account/welcome');
                            }
                        },
                        () => {
                            window.location.href = '/account';
                        }
                    );
                } else {
                    (<any>this.$root.$refs).signInPanel.onSignInByOneTimePassword();
                }
            });
        }
    }
}
